export { default } from './ClickAwayListener';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/ClickAwayListener/index.js
// module id = 448
// module chunks = 121